/**************
 Mobile Nav
 ***************/

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));